import type { ApolloError } from '@apollo/client';

export const isApolloError = (error: Error): error is ApolloError => {
  return 'graphQLErrors' in error;
};
